export const wasMemberIngested = (patient: fhir.Patient | null) => {
  const ingestedPatient = patient?.meta?.tag?.find(tag => {
    const isKnownPatient =
      tag.code === 'SMART on FHIR Patient' || tag.code === 'Elation Patient';
    const isKnownSource =
      tag.system === 'http://lifeomic.com/fhir/source' ||
      tag.system === 'http://lifeomic.com/fhir/source-type';
    return isKnownPatient && isKnownSource;
  });

  return Boolean(ingestedPatient);
};

export const shouldCollapseMemberHeader = ({
  contentWidth,
  totalHeaderWidth,
  maxRatio = 0.4,
}: {
  contentWidth: number;
  totalHeaderWidth: number;
  maxRatio?: number;
}) => {
  if (totalHeaderWidth <= 0 || contentWidth <= 0) {
    return false;
  }

  return contentWidth > totalHeaderWidth * maxRatio;
};
